module.exports = __webpack_public_path__ + "img/7fea876.png";